<template>
<div>
  <el-col v-if="Object.keys(arrivalTransport).length !== 0" :xs="xs" :sm="sm" :md="md" :lg="lg" :xl="xl">
    <div>
      <i
        class="list-icon material-icons el-button--text rotate90"
        style="margin: 0 4px 10px 0;">
        flight
      </i>
      <div
        class="list-icon"
        style="margin-top: 3px;">
        <b>{{ $t('ibe.outward_flight')}}</b>
      </div>
    </div>
    <div style="clear:both;"></div>
   <template v-for="item in arrivalTransport.segments">
      <el-row
        :key="'arrivalFlight_' + item.departureCode"
        :class="fontClass"
        style="margin-bottom: 5px;">
        <el-col :xs="7" :sm="6" :md="6" :lg="7" :xl="6">
          <b>{{ item | flightDateString(_self) }}</b>
        </el-col>
        <el-col :xs="17" :sm="18" :md="18" :lg="17" :xl="18">
            <div>
              <b>{{ item | flightTimeString(_self) }}</b>
            </div>
            <div>
              {{ item.departureName }} ({{ item.departureCode }}) - {{ item.arrivalName }} ({{ item.arrivalCode }})
            </div>
            <div>
              {{ item.airlineName }}
            </div>
            <div>
              {{ arrivalTransport.text.class }} ({{ arrivalTransport.ibeData.katCode }})
            </div>
            <!-- <div>
              {{ $t('ibe.freeBaggage', {amount: item.baggageInfo}) }}
            </div> -->
        </el-col>
      </el-row>
    </template>
  </el-col>
  <el-col v-if="Object.keys(returnTransport).length !== 0" :xs="xs" :sm="sm" :md="md" :lg="lg" :xl="xl">
    <div>
      <i
        class="list-icon material-icons el-button--text rotate270"
        style="margin: 0 4px 10px 0;">
        flight
      </i>
      <div
        class="list-icon"
        style="margin-top: 3px;">
        <b>{{ $t('ibe.return_flight')}}</b>
      </div>
    </div>
    <div style="clear:both;"></div>
    <template v-for="item in returnTransport.segments">
      <el-row
        :key="'arrivalFlight_' + item.departureCode"
        :class="fontClass"
        style="margin-bottom: 5px;">
        <el-col :xs="7" :sm="6" :md="6" :lg="7" :xl="6">
          <b>{{ item | flightDateString(_self) }}</b>
        </el-col>
        <el-col :xs="17" :sm="18" :md="18" :lg="17" :xl="18">
            <div>
              <b>{{ item | flightTimeString(_self) }}</b>
            </div>
            <div>
              {{ item.departureName }} ({{ item.departureCode }}) - {{ item.arrivalName }} ({{ item.arrivalCode }})
            </div>
            <div>
              {{ item.airlineName }} {{ item.flightNumber }}
            </div>
            <div>
              {{ returnTransport.text.class }} ({{ returnTransport.ibeData.katCode }})
            </div>
            <div>
              {{ $t('ibe.freeBaggage', {amount: item.baggageInfo}) }}
            </div>
        </el-col>
      </el-row>
    </template>
  </el-col>
  <el-col :span="24"
    :class="fontClass" style="margin-bottom: 5px;">
    <div>{{ $t('ibe.text_flight_details') }}</div>
    <div>{{ $t('ibe.text_local_time') }}</div>
  </el-col>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FlightDetails',
  props: ['xs', 'sm', 'md', 'lg', 'xl', 'fontClass'],
  computed: {
    ...mapGetters('booking', [
      'arrivalTransport',
      'returnTransport'
    ])
  }
}
</script>
